module.exports = __webpack_public_path__ + "img/login.356a9469.png";